import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  
  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;
    console.log('userInfo:', userInfo)

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        push(carAddRef, car);
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        set(carEditRef(car.id),car);
    }
  }

  export const updateUserCarWithImage = (newData, blob, frontBlob, backBlob) => (dispatch) => {
    const {
        auth,
        carAddRef,
        singleUserRef,
        carImage
    } = firebase;

    const carId = push(carAddRef).key;

    // Upload the main car image
    const mainImageUpload = uploadBytesResumable(carImage(carId), blob).then(() => {
        blob.close();
        return getDownloadURL(carImage(carId));
    });

    // Upload the front car image
    const frontImageUpload = uploadBytesResumable(carImage(`${carId}front`), frontBlob).then(() => {
        frontBlob.close();
        return getDownloadURL(carImage(`${carId}front`));
    });

    // Upload the back car image
    const backImageUpload = uploadBytesResumable(carImage(`${carId}back`), backBlob).then(() => {
        backBlob.close();
        return getDownloadURL(carImage(`${carId}back`));
    });

    // Wait for all three uploads to complete
    Promise.all([mainImageUpload, frontImageUpload, backImageUpload])
        .then(([carImageUrl, frontImageUrl, backImageUrl]) => {
            newData.car_image = carImageUrl;
            newData.car_front_image = frontImageUrl;
            newData.car_back_image = backImageUrl;
            set(child(carAddRef, carId), newData);
            
            if (newData.active) {
                const updateData = {
                    carType: newData.carType,
                    vehicleNumber: newData.vehicleNumber,
                    vehicleMake: newData.vehicleMake,
                    vehicleModel: newData.vehicleModel,
                    other_info: newData.other_info,
                    car_image: carImageUrl,
                    car_front_image: frontImageUrl,
                    car_back_image: backImageUrl,
                    carApproved: newData.approved,
                    updateAt: new Date().getTime()
                };
                update(singleUserRef(auth.currentUser.uid), updateData);
            }
        })
        .catch(error => {
            console.error("Error uploading images: ", error);
        });
};
